export * from '../../server/config/environment/shared';
